import swal from 'sweetalert';

class Alert {

    init() {
        this.parse(window.Alert)
    }

    parse(data) {

        if(data === undefined)
            return

        switch(data.type) {

            case 'success':
                this.success(data.text, data.title)
                break;
			case 'error':
                this.error(data.text, data.title)
                break;

        }

    }

    error(text, title) {

        swal({
            title: title ? title : 'Error!',
            text: text,
            icon: "error",
        })
    }

	success(text, title) {
		swal({
			title: title ? title : 'OK!',
			text: text,
			icon: "success",
		})
	}

}

export default new Alert



// WEBPACK FOOTER //
// ./resources/assets/js/modules/Alert.js